import {memo, useContext, useEffect, useRef} from "react";
import {Accordion, AccordionContext, useAccordionButton} from "react-bootstrap";
import useUpdateEffect from "../../hooks/useUpdateEffect";

export const AccordionToggle = memo(({children, eventKey, onClose, onOpen}) => {
    const {activeEventKey} = useContext(AccordionContext);
    const decoratedOnClick = useAccordionButton(eventKey);
    const activeEventKeyPrev = useRef(activeEventKey);
    useUpdateEffect(() => {
        if (activeEventKey === activeEventKeyPrev.current) {
            return;
        }
        if (eventKey === activeEventKey) {
            onOpen && onOpen();
        } else {
            onClose && onClose();
        }
    }, [eventKey, activeEventKey, onOpen, onClose]);

    useEffect(() => {
        activeEventKeyPrev.current = activeEventKey;
    }, [activeEventKey])

    return (
            <Accordion.Header onClick={decoratedOnClick}>{children}</Accordion.Header>
    )
})